import apiClient, { safeJson } from '@/api/client';

export const retrieveAccessToken = async (accessToken: string, refreshToken: string) => {
    const res = await apiClient.post('v1/auth/refresh-tokens', {
        headers: { refreshToken, authorization: accessToken },
    });
    return res.json<{ access: { token: string; expires: number } }>();
};

export const checkAccessToken = async (accessToken: string) => {
    return apiClient.get('v1/auth/health-check', {
        headers: { authorization: accessToken },
    });
};

export const storeDeviceToken = async (accessToken: string, deviceToken: string) => {
    const res = await apiClient.post('v1/auth/device-token', {
        headers: { authorization: accessToken },
        json: { deviceToken },
    });
    return res.json<any>();
};

export const deleteDeviceToken = async (deviceToken: string) => {
    return apiClient.delete('v1/auth/device-token', {
        json: { deviceToken },
    });
};

export const alertUpdate = async ({ alert, type }: { alert: boolean; type: 'feed' | 'default' }) => {
    const body = type === 'feed' ? { feedAlert: alert } : { alert };
    const res = await apiClient.patch('v1/auth/setting', {
        json: body,
    });
    const data = await safeJson(res);
    return { status: res.status, data };
};

export const getAuth = async () => {
    const res = await apiClient.get('v1/auth');
    const data = await safeJson(res);
    return { status: res.status, data };
};

export const postDeviceInfo = async ({
    appVersion,
    osVersion,
    deviceInfo,
}: {
    appVersion: string;
    osVersion: string;
    deviceInfo: string;
}) => {
    const res = await apiClient.post('v1/auth/device-info', {
        json: { appVersion, osVersion, deviceInfo },
    });
    const data = await safeJson(res);
    return { status: res.status, data };
};

export const updateProfileImageAPI = async ({ imgBase64 }: { imgBase64: string }) => {
    try {
        const response = await apiClient.patch('v1/images/profile', {
            json: { imgBase64 },
        });
        const data = await safeJson(response);
        return { status: response.status, data };
    } catch (error) {
        throw new Error('프로필 이미지를 변경하지 못했습니다.');
    }
};

export const retrieveSandBirdToken = async (userId: string, accessToken: string) => {
    const res = await apiClient.post('v1/auth/sendbird-token', {
        json: { userId },
        headers: { authorization: accessToken },
    });
    return res.json<any>();
};
